import React from 'react';
import ChangeAddress from '../pages/ChangeAddress';

export const changeAddressRoutePage = {
  component: <ChangeAddress />,
  route: '/alteracao-de-endereco',
};
